<script lang="ts" setup>
import type {Area} from "#magnolia-layer/types/magnolia-types";
import ErrorDisplayConcise from "~/components/ErrorDisplayConcise.vue";
import {joinURL} from "ufo";
import type {PublicationRoot} from "~/types/mgnl";

const props = defineProps<{
  metadata: Area;
  rootLink: string;
}>();

const {t} = useI18n();
const runtimeConfig = useRuntimeConfig();

const {data, error} = await useMagnoliaFetch<PublicationRoot>(
  joinURL(runtimeConfig.public.mgnl.apiLibrary, props.rootLink),
  {
    transform: (node) => mapNodes<PublicationRoot>(node),
  },
);

useErrorStatusForwarding(error);
</script>

<template>
  <section class="col-span-full content-grid pb-22">
    <h1 class="sr-only">{{ t("label.overview") }}</h1>
    <ErrorDisplayConcise v-if="error" :error></ErrorDisplayConcise>
    <div class="grid gap-22" v-else-if="data">
      <section v-for="group in data.children" :key="group['@id']">
        <h2 class="text-4xl lg:text-7xl mb-9 first-letter:uppercase">
          {{ group.jcrName }}
        </h2>
        <div
          class="articles grid grid-cols-12 gap-x-3 lg:gap-x-6 gap-y-12 lg:gap-y-24 items-start">
          <LibraryCard
            v-for="publication in group.children"
            :key="publication['@id']"
            :publication />
        </div>
      </section>
    </div>
  </section>
</template>
